import React from "react";

const PanelFooter = ({ children }) => {
    return <div className="Tile-foot">{children}</div>;
};
export default PanelFooter;
